{
  "addons.addonList": "추가 기능 목록",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "이 링크에서 API 키를 생성하고 검색하세요.",
  "addons.ambientWeatherDescription": "주변 기상 관측소(WS-5000, WS-2000, WS-2902C,...)",
  "addons.apiKey": "API 키",
  "addons.applicationKey": "애플리케이션 키",
  "addons.connect": "연결하다",
  "addons.davisApiSecret": "API 비밀",
  "addons.davisApiV2Key": "V2 API 키",
  "addons.davisDescription": "데이비스 기상 관측소(Vantage Vue, Vantage Pro2,...)",
  "addons.davisRetrieveApiKey": "이 링크에서 V2 API 키를 검색하세요.",
  "addons.disconnect": "연결 끊기",
  "addons.ecowittCreateAndRetrieveKeys": "이 링크에서 API 키와 애플리케이션 키를 모두 생성하고 검색하세요.",
  "addons.ecowittDescription": "Ecowitt는 전문 Wi-Fi 기상 관측소, 무선 실내 실외 온도계, 습도 모니터, 고정밀 우량계, 공기 품질 모니터 등을 제공합니다.",
  "addons.helpLink": "{provider} 연결 방법",
  "addons.myAcuriteAccountOnHold": "귀하의 계정이 보류되었습니다. 계정을 다시 연결하려면 비밀번호를 입력하세요",
  "addons.myAcuriteDescription": "AcuRite는 북미 최고의 기상 관측소 브랜드입니다. 시간, 온도, 기상 기술 분야의 선두주자인 AcuRite는 실내 및 실외 환경에 대한 자세한 정보를 제공하므로 귀하는 자신 있게 하루를 계획할 수 있습니다.",
  "addons.myAcuriteEnterCredentials": "My AcuRite 계정을 SmartMixin과 연결하려면 My AcuRite 자격 증명을 입력하세요.",
  "addons.netatmoEnergy": "네타트모 에너지",
  "addons.netatmoEnergyDescription": "Netatmo 온도 조절기를 사용하여 침대에서나 지구 반대편에서 집의 온도를 변경하세요.",
  "addons.netatmoThermostat": "Netatmo 온도 조절기",
  "addons.netatmoWeather": "네타트모날씨",
  "addons.netatmoWeatherDescription": "집에 있는 개인 기상 관측소",
  "addons.or": "또는",
  "addons.providerAccountDisconnected": "기상 서비스 연결이 만료되었습니다. 데이터 업데이트를 재개하려면 다시 연결해 주세요.",
  "addons.reconnect": "다시 연결",
  "addons.weatherflowCreateToken": "이 링크에서 토큰을 생성하고 검색하세요.",
  "addons.weatherflowTempestDescription": "풍속계, 우량계가 내장된 폭풍우 기상 시스템",
  "addons.wundergroundApiKey": "API 키",
  "addons.wundergroundDescription": "Weather Underground는 기상 관측소 및 대기 질 모니터와 같은 환경 센서의 데이터를 연결하는 사람들로 구성된 글로벌 커뮤니티로, 열정을 키우는 데 필요한 풍부한 지역 데이터를 제공할 수 있습니다.",
  "addons.wundergroundRetrieveApiKey": "이 링크에서 API 키를 검색하세요.",
  "addons.wundergroundRetrieveStationId": "이 링크에서 스테이션 ID를 검색하세요",
  "addons.wundergroundStationId": "스테이션 ID",
  "airQuality.airQuality": "공기질",
  "airQuality.airQualityIndex": "대기 질 지수",
  "airQuality.co": "일산화탄소",
  "airQuality.good": "좋은",
  "airQuality.goodDescription": "대기 질은 만족스러운 것으로 간주되며 대기 오염으로 인한 위험은 거의 또는 전혀 없습니다.",
  "airQuality.hazardous": "위험한",
  "airQuality.hazardousDescription": "건강 경고: 누구나 건강에 더 심각한 영향을 미칠 수 있습니다",
  "airQuality.indoorAirQuality": "실내공기질",
  "airQuality.moderate": "보통의",
  "airQuality.moderateDescription": "공기질은 괜찮습니다. 그러나 일부 오염 물질의 경우 대기 오염에 매우 민감한 극소수의 사람들에게는 중간 정도의 건강 문제가 있을 수 있습니다.",
  "airQuality.no2": "이산화질소",
  "airQuality.o3": "오존",
  "airQuality.pm10": "직경 10μm 이하의 입자",
  "airQuality.pm25": "직경 2.5μm 이하의 입자",
  "airQuality.sensitiveUnhealthy": "민감한 사람에게는 건강에 해로움",
  "airQuality.sensitiveUnhealthyDescription": "민감한 그룹의 구성원은 건강에 영향을 미칠 수 있습니다. 일반 대중은 영향을 받을 가능성이 없습니다.",
  "airQuality.so2": "이산화황",
  "airQuality.unhealthy": "건강에 해로운",
  "airQuality.unhealthyDescription": "모든 사람이 건강에 영향을 받기 시작할 수 있습니다. 민감한 그룹의 구성원은 건강에 더 심각한 영향을 미칠 수 있습니다.",
  "airQuality.veryUnhealthy": "매우 건강에 해로움",
  "airQuality.veryUnhealthyDezscription": "비상 상황에 대한 건강 경고. 전체 인구가 영향을 받을 가능성이 더 높습니다.",
  "alerts.addAlert": "알림 추가",
  "alerts.addCondition": "조건 추가",
  "alerts.alertAdded": "알림이 추가되었습니다.",
  "alerts.alertAuthorizationNotice": "알림은 SmartMixin이 알림을 표시하도록 승인한 경우에만 작동합니다.",
  "alerts.alertDeleted": "알림이 삭제되었습니다.",
  "alerts.alertEdited": "알림이 수정되었습니다.",
  "alerts.alertName": "경고 이름",
  "alerts.alertWhen": "다음과 같은 경우에 알림을 받고 싶습니다.",
  "alerts.aqiGreaterThan": "다음보다 큰 AQI",
  "alerts.aqiGreaterThanThreshold": "AQI가 {value}{unit} 임계값보다 큼",
  "alerts.aqiLessThan": "AQI 미만",
  "alerts.aqiLessThanThreshold": "AQI가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.atLeastOneCondition": "조건을 하나 이상 추가해야 합니다.",
  "alerts.co2GreaterThan": "CO2가 다음보다 큼",
  "alerts.co2GreaterThanThreshold": "CO2가 {value}{unit} 임계값보다 큼",
  "alerts.co2LessThan": "CO2 미만",
  "alerts.co2LessThanThreshold": "CO2가 {value}{unit} 기준치보다 낮습니다.",
  "alerts.conditions": "정황",
  "alerts.createAlert": "알림 만들기",
  "alerts.dailyPrecipitationGreaterThan": "일 강수량 초과",
  "alerts.dailyPrecipitationGreaterThanThreshold": "일 강수량 {value}{unit} 임계값 초과",
  "alerts.deleteAlert": "알림 삭제",
  "alerts.editAlert": "알림 수정",
  "alerts.editCondition": "조건 편집",
  "alerts.gustSpeedGreaterThan": "다음보다 큰 돌풍 속도",
  "alerts.gustSpeedGreaterThanThreshold": "{value}{unit} 임계값보다 큰 돌풍 속도",
  "alerts.gustSpeedLessThan": "돌풍 속도 미만",
  "alerts.gustSpeedLessThanThreshold": "돌풍 속도가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.heatIndexGreaterThan": "열지수 초과",
  "alerts.heatIndexGreaterThanThreshold": "열지수가 {value}{unit} 임계값보다 높습니다.",
  "alerts.heatIndexLessThan": "열지수 미만",
  "alerts.heatIndexLessThanThreshold": "열지수가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.humidexGreaterThan": "휴미덱스 초과",
  "alerts.humidexGreaterThanThreshold": "휴미덱스가 {value}{unit} 임계값보다 높습니다.",
  "alerts.humidexLessThan": "휴미덱스 미만",
  "alerts.humidexLessThanThreshold": "휴미덱스가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.humidityGreaterThan": "다음보다 높은 습도",
  "alerts.humidityGreaterThanThreshold": "{value}{unit} 임계값보다 높은 습도",
  "alerts.humidityLessThan": "습도 미만",
  "alerts.humidityLessThanThreshold": "{value}{unit} 임계값보다 낮은 습도",
  "alerts.inProgress": "진행 중",
  "alerts.myAlerts": "내 알림",
  "alerts.noConfiguredAlert": "아직 구성된 알림이 없습니다. 알림을 추가하세요.",
  "alerts.noiseGreaterThan": "다음보다 큰 소음",
  "alerts.noiseGreaterThanThreshold": "{value}{unit} 임계값보다 큰 노이즈",
  "alerts.noiseLessThan": "소음 미만",
  "alerts.noiseLessThanThreshold": "{value}{unit} 임계값보다 작은 소음",
  "alerts.noteOnConditions": "아래 조건이 모두 확인되면 경고가 트리거됩니다.",
  "alerts.pm10GreaterThan": "PM 10 이상",
  "alerts.pm10GreaterThanThreshold": "PM 10이 {value}{unit} 임계값보다 큼",
  "alerts.pm10LessThan": "PM 10 미만",
  "alerts.pm10LessThanThreshold": "PM 10이 {value}{unit} 임계값보다 적습니다.",
  "alerts.pm1GreaterThan": "PM 1보다 큼",
  "alerts.pm1GreaterThanThreshold": "PM 1이 {value}{unit} 임계값보다 큼",
  "alerts.pm1LessThan": "PM 1 미만",
  "alerts.pm1LessThanThreshold": "PM 1이 {value}{unit} 임계값보다 작습니다.",
  "alerts.pm2p5GreaterThan": "PM 2.5 이상",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5가 {value}{unit} 임계값보다 큼",
  "alerts.pm2p5LessThan": "PM 2.5 미만",
  "alerts.pm2p5LessThanThreshold": "PM 2.5가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.postStormSummary": "강우 후 요약",
  "alerts.postStormSynopsisHelper": "강우가 끝날 때마다 요약 알림을 받게 됩니다.",
  "alerts.postStormSynopsisSoleCondition": "폭풍 후 요약은 다른 조건과 결합할 수 없습니다.",
  "alerts.precipitationGreaterThan": "시간당 강수량 초과",
  "alerts.precipitationGreaterThanThreshold": "시간당 강수량 {value}{unit} 임계값 초과",
  "alerts.pressureGreaterThan": "다음보다 큰 압력",
  "alerts.pressureGreaterThanThreshold": "{value}{unit} 임계값보다 큰 압력",
  "alerts.pressureLessThan": "압력 미만",
  "alerts.pressureLessThanThreshold": "{value}{unit} 임계값보다 낮은 압력",
  "alerts.rainRateGreaterThan": "강수 강도 초과",
  "alerts.rainRateGreaterThanThreshold": "강수 강도 {value}{unit} 임계값 초과",
  "alerts.solarRadiationGreaterThan": "다음보다 큰 태양 복사",
  "alerts.solarRadiationGreaterThanThreshold": "{value}{unit} 임계값보다 큰 태양 복사",
  "alerts.solarRadiationLessThan": "다음보다 적은 태양 복사",
  "alerts.solarRadiationLessThanThreshold": "{value}{unit} 임계값보다 작은 태양 복사",
  "alerts.temperatureGreaterThan": "다음보다 큰 온도",
  "alerts.temperatureGreaterThanThreshold": "{value}{unit} 임계값보다 높은 온도",
  "alerts.temperatureLessThan": "온도 미만",
  "alerts.temperatureLessThanThreshold": "온도가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.thswGreaterThan": "THSW 초과",
  "alerts.thswGreaterThanThreshold": "THSW가 {value}{unit} 임계값보다 높습니다.",
  "alerts.thswLessThan": "THSW 미만",
  "alerts.thswLessThanThreshold": "THSW가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.thwGreaterThan": "THW 초과",
  "alerts.thwGreaterThanThreshold": "THW가 {value}{unit} 임계값보다 높습니다.",
  "alerts.thwLessThan": "THW 미만",
  "alerts.thwLessThanThreshold": "THW가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.uvGreaterThan": "UV 지수가 다음보다 큼",
  "alerts.uvGreaterThanThreshold": "UV 지수가 {value}{unit} 임계값보다 큽니다.",
  "alerts.uvLessThan": "자외선 지수 미만",
  "alerts.uvLessThanThreshold": "UV 지수가 {value}{unit} 임계값보다 작습니다.",
  "alerts.visibilityGreaterThanThreshold": "가시성이 {value}{unit} 기준점보다 큼",
  "alerts.visibilityLessThanThreshold": "가시성이 {value}{unit} 기준점보다 낮습니다.",
  "alerts.visiblityGreaterThan": "다음보다 큰 가시성",
  "alerts.visiblityLessThan": "가시성 미만",
  "alerts.whichMeasure": "어떤 조치에 대해 알림을 받고 싶으신가요?",
  "alerts.whichModule": "어떤 모듈에 대해 경고하고 싶습니까?",
  "alerts.windChillGreaterThan": "차가운 바람 초과",
  "alerts.windChillGreaterThanThreshold": "차가운 바람가 {value}{unit} 임계값보다 높습니다.",
  "alerts.windChillLessThan": "차가운 바람 미만",
  "alerts.windChillLessThanThreshold": "차가운 바람가 {value}{unit} 임계값보다 낮습니다.",
  "alerts.windSpeedGreaterThan": "보다 큰 풍속",
  "alerts.windSpeedGreaterThanThreshold": "{value}{unit} 임계값보다 큰 풍속",
  "alerts.windSpeedLessThan": "풍속 미만",
  "alerts.windSpeedLessThanThreshold": "{value}{unit} 임계값보다 낮은 풍속",
  "astral.astronomicalSunPhase": "천문학적 {sunPhase}",
  "astral.civilSunPhase": "토목 {sunPhase}",
  "astral.dawn": "새벽",
  "astral.dusk": "황혼",
  "astral.firstQuarter": "1분기",
  "astral.fullMoon": "보름달",
  "astral.lastQuarter": "마지막 분기",
  "astral.moon": "달",
  "astral.moonPhases": "달의 위상",
  "astral.moonrise": "월출",
  "astral.moonset": "월몰",
  "astral.nauticalSunPhase": "해상 {sunPhase}",
  "astral.newMoon": "뉴 문",
  "astral.noon": "정오",
  "astral.remainingDaylight": "남은 일광",
  "astral.sunrise": "해돋이",
  "astral.sunriseAndSunset": "일출과 일몰",
  "astral.sunriseAt": "일출 {time}",
  "astral.sunset": "일몰",
  "astral.sunsetAt": "일몰 {time}",
  "astral.totalDaylight": "총 일광",
  "astral.waningCrescent": "쇠퇴하는 초승달",
  "astral.waningGibbous": "쇠퇴하는 만세",
  "astral.waxingCrescent": "왁싱 초승달",
  "astral.waxingGibbous": "왁싱 만세",
  "auth.alreadyHaveAccount": "이미 계정이 있으신가요?",
  "auth.authContainerTagline": "나만의 날씨 대시보드. 스테이션을 연결하고 실시간 데이터를 손끝에서 확인하세요.",
  "auth.backToLogin": "로그인으로 돌아가기",
  "auth.catchPhrase": "기상정보 플랫폼",
  "auth.checkYourEmail": "이메일을 확인하세요",
  "auth.continueWithApple": "Apple로 계속하기",
  "auth.continueWithFacebook": "Facebook으로 계속하기",
  "auth.continueWithGoogle": "Google로 계속하기",
  "auth.email": "이메일 주소",
  "auth.emailRequiredLoginFacebook": "이메일 권한이 필요합니다.",
  "auth.emailVerification": "이메일 인증",
  "auth.emailVerificationFailure": "이메일 확인에 문제가 발생했습니다.",
  "auth.emailVerificationSuccess": "귀하의 이메일이 성공적으로 확인되었습니다.",
  "auth.firstName": "이름",
  "auth.forgotPassword": "비밀번호를 잊어 버렸습니까?",
  "auth.forgotPasswordSubtitle": "이메일을 입력하시면 비밀번호 재설정 링크를 보내드립니다.",
  "auth.lastName": "성",
  "auth.login": "로그인",
  "auth.loginSubtitle": "다시 오신 것을 환영합니다! 정보를 입력해 주세요.",
  "auth.loginToSmartMixinDescription": "계정에 액세스하려면 SmartMixin 자격 증명을 입력하세요.",
  "auth.logout": "로그 아웃",
  "auth.logoutConfirmation": "정말로 로그아웃하시겠습니까?",
  "auth.noAccountYet": "아직 계정이 없으신가요?",
  "auth.or": "또는",
  "auth.password": "비밀번호",
  "auth.passwordAgain": "비밀번호를 다시 입력하세요",
  "auth.passwordReset": "비밀번호 초기화",
  "auth.passwordResetSuccess": "귀하의 비밀번호가 성공적으로 업데이트되었습니다.",
  "auth.register": "계정 만들기",
  "auth.registerDescription": "무료 SmartMixin 계정을 만들어 기상 관측소를 연결하고, 날씨 데이터를 추적하고, 강력한 분석 도구에 액세스하세요.",
  "auth.registerSubtitle": "시작하려면 계정을 만드세요.",
  "auth.registerSuccess": "성공적으로 등록되었습니다! 추가 지침이 포함된 확인 링크를 {emailAddress} 로 보내드렸습니다.",
  "auth.restorePassword": "비밀번호 복원",
  "auth.restorePasswordSuccess": "추가 지침이 포함된 비밀번호 재설정 링크를 {emailAddress} 로 보내드렸습니다.",
  "auth.sendReset": "재설정 지침 보내기",
  "auth.socialAccount": "또는 귀하의 계정을 사용하십시오",
  "auth.welcome": "SmartMixin에 오신 것을 환영합니다",
  "auth.welcomeBack": "돌아온 것을 환영합니다!",
  "calendar.april": "4월",
  "calendar.august": "8월",
  "calendar.dateFormat": "날짜 형식",
  "calendar.day": "낮",
  "calendar.december": "12월",
  "calendar.end": "끝",
  "calendar.february": "2월",
  "calendar.hours": "시간",
  "calendar.hoursShort": "시간",
  "calendar.january": "1월",
  "calendar.july": "7월",
  "calendar.june": "6월",
  "calendar.last24Hours": "지난 24시간",
  "calendar.last30Days": "지난 30일",
  "calendar.last7Days": "지난 7일",
  "calendar.march": "3월",
  "calendar.max": "맥스",
  "calendar.may": "5월",
  "calendar.month": "월",
  "calendar.months": "개월",
  "calendar.november": "11월",
  "calendar.october": "10월",
  "calendar.oneDay": "1 일",
  "calendar.oneHour": "1 시간",
  "calendar.oneMonth": "1 개월",
  "calendar.oneWeek": "일주",
  "calendar.previous24Hours": "지난 24시간",
  "calendar.previous30Days": "지난 30일",
  "calendar.previous7Days": "지난 7일",
  "calendar.previousDay": "전날",
  "calendar.previousMonth": "지난달",
  "calendar.previousWeek": "지난주",
  "calendar.previousYear": "전년도",
  "calendar.sameDayLastYear": "작년 같은 날",
  "calendar.sameMonthLastYear": "작년 같은 달",
  "calendar.selectADate": "날짜를 선택하십시오",
  "calendar.selectAMonth": "한 달을 선택하십시오",
  "calendar.selectAYear": "1 년을 선택하십시오",
  "calendar.selectGranularity": "세부사항 선택",
  "calendar.selectTimescale": "시간 척도 선택",
  "calendar.september": "9월",
  "calendar.sixHours": "6시간",
  "calendar.start": "시작",
  "calendar.thirtyMinutes": "30 분",
  "calendar.threeHours": "3시간",
  "calendar.use24HourFormat": "24시간 형식을 사용하세요",
  "calendar.week": "주",
  "calendar.year": "년도",
  "calendar.yesterday": "어제",
  "common.accountDeleted": "귀하의 계정이 성공적으로 삭제되었습니다.",
  "common.accountOnHold": "계정 연결이 만료되었습니다. 데이터 업데이트를 재개하려면 다시 연결해 주세요.",
  "common.add": "추가하다",
  "common.addAStation": "역 추가",
  "common.addToFavorites": "즐겨 찾기에 추가",
  "common.addYourOwnStation": "나만의 방송국 추가",
  "common.alreadyPremium": "당신은 이미 프리미엄 계정을 가지고 있습니다!",
  "common.alsoAvailableOn": "다음에서도 이용 가능:",
  "common.altitude": "고도",
  "common.analysis": "분석",
  "common.aroundMe": "내 주변",
  "common.articleCount": "{count}개의 기사",
  "common.articleNotFound": "기사를 찾을 수 없음",
  "common.articleNotFoundDescription": "찾고 있는 기사가 존재하지 않습니다.",
  "common.average": "평균",
  "common.averageOverThePeriod": "해당 기간의 평균",
  "common.away": "떨어져 있는",
  "common.back": "뒤로",
  "common.backToHelpCenter": "도움말 센터로 돌아가기",
  "common.backToHome": "홈으로 돌아가기",
  "common.bad": "나쁜",
  "common.batteryLevel": "배터리 잔량",
  "common.bestValue": "최고의 가치",
  "common.billingDetailsAndroid": "무료 평가판 제안의 경우 무료 소개 기간이 만료되기 24시간 전에 취소하면 요금이 청구되지 않습니다. 평가판 기간이 끝나면 Google Play 계정 설정을 통해 언제든지 SmartMixin 구독을 취소할 수 있으며 그렇지 않으면 자동으로 갱신됩니다. 위 버튼에 표시된 추가 요금이 청구되는 것을 방지하려면 구독 기간이 종료되기 24시간 전에 완료해야 합니다. 구독 결제는 구매 확인 및 각 갱신 기간 시작 시 Google Play 계정으로 청구됩니다.",
  "common.billingDetailsIos": "무료 평가판 제안의 경우 무료 소개 기간이 만료되기 24시간 전에 취소하면 요금이 청구되지 않습니다. 평가판 기간이 끝나면 App Store 계정 설정을 통해 언제든지 SmartMixin 구독을 취소할 수 있으며 그렇지 않으면 자동으로 갱신됩니다. 위 버튼에 표시된 추가 요금이 청구되는 것을 방지하려면 구독 기간이 종료되기 24시간 전에 완료해야 합니다. 구독 결제는 구매 확인 및 각 갱신 기간 시작 시 App Store 계정으로 청구됩니다.",
  "common.boilerOn": "보일러 ON",
  "common.browseByCategory": "카테고리별 탐색",
  "common.calendarView": "달력 보기",
  "common.cancel": "취소",
  "common.cannotBeEmpty": "이 필드는 비워둘 수 없습니다.",
  "common.cardDetails": "카드 세부정보",
  "common.categoryNotFound": "카테고리를 찾을 수 없습니다",
  "common.categoryNotFoundDescription": "이 카테고리가 존재하지 않거나 기사가 없습니다.",
  "common.charts": "차트",
  "common.chartView": "차트 보기",
  "common.clearRecentLocations": "모든 것을 지우십시오",
  "common.close": "닫다",
  "common.comparison": "비교",
  "common.currentDay": "오늘날",
  "common.currentLocation": "현재 위치",
  "common.currentObservations": "현재 관찰",
  "common.currentRainEvent": "현재 비 이벤트",
  "common.currentRate": "현재 환율",
  "common.currentWeatherConditions": "현재 조건",
  "common.customizeComparisonMetrics": "지표 맞춤설정",
  "common.customizeComparisonMetricsDescription": "항목을 드래그하여 비교 지표를 재정렬하세요. 눈 아이콘을 탭하여 지표를 표시하거나 숨길 수 있습니다.",
  "common.customizeDashboard": "사용자 지정",
  "common.customizeDashboardDescription": "항목을 드래그하여 대시보드를 재정렬하세요. 눈 아이콘을 탭하여 섹션을 표시하거나 숨기세요.",
  "common.customizedStationName": "맞춤형 역 이름",
  "common.dailyForecast": "일일예보",
  "common.dashboard": "계기반",
  "common.default": "기본값",
  "common.defaultForecastModelChip": "기본값 · {name}",
  "common.delete": "삭제",
  "common.deleteAccount": "계정 삭제",
  "common.deleteAccountConfirmation": "정말로 계정을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.",
  "common.deleteAccountDescription": "이 작업을 수행하면 귀하의 계정과 모든 정보가 삭제됩니다. 돌아갈 수 없습니다.",
  "common.details": "세부",
  "common.edit": "편집하다",
  "common.editor": "편집자",
  "common.endTime": "종료 시간",
  "common.exitFullscreen": "전체 화면 종료",
  "common.exploreWeatherMap": "날씨 지도 탐색",
  "common.favoriteLocations": "즐겨 찾기",
  "common.favoriteLocationsEmpty": "최대 5 개의 좋아하는 위치를 추가 할 수 있습니다.",
  "common.favoriteStations": "즐겨찾는 방송국",
  "common.feedbackHelpsImprove": "여러분의 의견은 도움말 문서 개선에 사용됩니다.",
  "common.filterStationDescription": "신뢰할 수 없는 측정값이 있는 스테이션을 표시하지 않음",
  "common.filterStations": "방송국 필터링",
  "common.filterStationSourceDescription": "지도에 표시할 역 제공자를 선택하세요.",
  "common.findStationsNearYou": "주변 관측소 찾기",
  "common.firmwareVersion": "펌웨어 버전",
  "common.forecast": "예측",
  "common.forecastComparisonDescription": "여러 소스의 예측 모델 결과를 쉽게 비교",
  "common.forecastModelComparison": "예측 모델 비교",
  "common.forecastModelCoverage": "적용 범위",
  "common.forecastModelDescription": "설명",
  "common.forecastModelDescription_AROME": "서유럽 상공의 대류 분해 가능 고해상도 Météo France 모델, 해상도 1.3km. 프랑스의 단기 예보에서 동급 최고; 3시간마다 업데이트.",
  "common.forecastModelDescription_ARPEGE_EU": "해상도 10km의 Météo France ARPEGE 모델의 유럽 둥지. 유럽 상공의 중기 예보, 하루 네 번 업데이트.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "해상도 25km의 Météo France 전 지구 수치 일기 예보 모델, 약 4일까지 실행. 하루 네 번 업데이트.",
  "common.forecastModelDescription_EC_GDPS": "Environment Canada의 전 지구 결정론적 예측 시스템: 해상도 15km의 전 세계 중기 모델, 10일까지 실행, 하루 두 번 업데이트.",
  "common.forecastModelDescription_EC_RDPS": "Environment Canada의 지역 결정론적 예측 시스템: 해상도 10km의 북미 상공 중기 모델, 하루 네 번 업데이트.",
  "common.forecastModelDescription_GFS": "NOAA의 주력 중거리 전 지구 모델. 해상도 25km로 전체 지구를 16일까지 다루며, 하루 네 번 업데이트.",
  "common.forecastModelDescription_HRRR_CONUS": "NOAA의 High-Resolution Rapid Refresh: 미국 본토 상공의 해상도 3km 대류 분해 가능 모델, 매시간 업데이트. 뇌우와 악기상의 매우 단기 예보에 가장 적합.",
  "common.forecastModelDescription_ICON_DE": "독일과 주변 국가 상공의 해상도 2.2km 대류 분해 가능 고해상도 DWD 모델. 단기 예보는 하루 두 번 업데이트.",
  "common.forecastModelDescription_ICON_EU": "해상도 7km의 DWD ICON 모델 유럽 둥지로 유럽과 북대서양을 다룸. 중기 예보는 하루 네 번 업데이트.",
  "common.forecastModelDescription_MET_NORWAY": "노르웨이 기상 연구소의 오픈 일기 예보 서비스로, 고해상도 북유럽 모델과 ECMWF 데이터를 결합하여 최대 10일 앞의 전 세계 예보를 제공.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "프랑스령 앤틸리스 제도(과들루프, 마르티니크) 상공의 해상도 2.5km AROME 둥지. 단기 예보는 하루 네 번 업데이트.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "프랑스령 기아나 상공의 해상도 2.5km AROME 둥지. 단기 예보는 하루 네 번 업데이트.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "뉴칼레도니아 상공의 해상도 2.5km AROME 둥지. 단기 예보는 하루 네 번 업데이트.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "프랑스령 폴리네시아 상공의 해상도 2.5km AROME 둥지. 단기 예보는 하루 네 번 업데이트.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "레위니옹과 마요트 상공의 해상도 2.5km AROME 둥지. 단기 예보는 하루 네 번 업데이트.",
  "common.forecastModelDescription_NAM_CONUS": "미국 본토 상공의 해상도 5km NOAA North American Mesoscale 모델 둥지. 단기 예보는 하루 네 번 업데이트.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "전체 북미를 32km 해상도로 다루는 NOAA North American Mesoscale 모델. 하루 네 번 업데이트.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "SmartMixin의 주력 예보. 귀하의 위치의 매시간에 대해 사용 가능한 최고의 모델을 선택합니다 — 일반적으로 존재하는 곳에서는 고해상도 지역 모델(프랑스의 AROME, 독일의 ICON-D2, 미국의 HRRR, 대륙 전체의 ARPEGE Europe…)이며 다른 곳에서는 전 지구 모델로 되돌아갑니다 — 그런 다음 인접한 소스에서 격차를 메웁니다. 그 결과는 세계 어디에서나 14일까지 다루는 단일하고 매끄러운 예보이며, 기본 모델 중 하나가 업데이트될 때마다 자동으로 새로 고쳐집니다.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Weatherflow의 독점적인 전 지구 예보로, 여러 수치 일기 예보 모델과 Tempest 기상 관측소 네트워크의 관측을 결합합니다. 10일 전 세계 지평선.",
  "common.forecastModelDetailTitle": "예보 모델",
  "common.forecastModelScopeGlobal": "전 지구",
  "common.forecastModelScopeGlobalDescription": "이 모델은 전 지구를 다룹니다.",
  "common.forecastModelScopeRegional": "지역",
  "common.forecastModelScopeRegionalDescription": "이 모델은 특정 지역만 다룹니다.",
  "common.forecastModelSpecifications": "사양",
  "common.forecastSources": "예측 소스",
  "common.freeAccount": "무료 계정",
  "common.freeSubscription": "무료 프리미엄 구독",
  "common.freeTrialForPeriod": "{period} 일 동안 무료 평가판",
  "common.frequency": "빈도",
  "common.full": "가득한",
  "common.fullscreen": "전체 화면",
  "common.getStartedFree": "무료로 시작하기",
  "common.getUnlimitedAccess": "무제한 액세스:",
  "common.good": "좋은",
  "common.help": "도움말",
  "common.helpCategoryAccount": "계정",
  "common.helpCategoryBilling": "결제",
  "common.helpCategoryGettingStarted": "시작하기",
  "common.helpCategoryProviders": "프로바이더",
  "common.helpCategoryStations": "스테이션",
  "common.helpCategoryTroubleshooting": "문제 해결",
  "common.helpCenter": "고객센터",
  "common.helpCenterDescription": "자주 묻는 질문에 대한 답변을 찾고 SmartMixin을 최대한 활용하는 방법을 알아보세요.",
  "common.hg": "프로스트 가드",
  "common.hidden": "숨김",
  "common.hiddenSensors": "숨겨진 센서",
  "common.hiddenStations": "숨겨진 방송국",
  "common.hiddenStationsDescription": "옆에 눈 아이콘을 두드려서 스테이션을 막을 수 있습니다.",
  "common.high": "높은",
  "common.home": "집",
  "common.homeConnectService": "기상 관측소를 보유하고 계신가요? 서비스를 연결하세요",
  "common.homeInformation": "홈 정보",
  "common.homeIntroduction": "SmartMixin 기능을 즐기려면 외부 계정 연결을 시작하세요.",
  "common.homeName": "집 이름",
  "common.homeSubtitle": "날씨 정보를 한곳에서",
  "common.horizon": "수평선",
  "common.horizonValue": "최대 {value} 시간",
  "common.iDontKnowYet": "아직은 모르겠어요",
  "common.indoor": "실내",
  "common.lastRainEvent": "마지막 비 이벤트",
  "common.lastUpdate": "마지막 업데이트",
  "common.legendLightningHelp": "색상은 지난 {minutes}분 동안 각 낙뢰의 경과 시간을 나타냅니다 — 최신은 흰색, 오래된 것은 짙은 빨간색입니다.",
  "common.legendNewest": "최신",
  "common.legendOldest": "오래됨",
  "common.legendStationsHelp": "마커 색상은 선택한 지표의 값을 나타냅니다.",
  "common.lightningDataAttribution": "번개 데이터: Blitzortung.org",
  "common.lightningStrikes": "낙뢰",
  "common.lightningStrikesDescription": "지도에 실시간 낙뢰 표시",
  "common.loading": "로드 중",
  "common.location": "위치",
  "common.locationAddedToFavorites": "즐겨 찾기에 추가 된 위치",
  "common.locationNotGranted": "위치 권한이 부여되지 않습니다. 장치 설정에서 위치에 액세스 할 수 있습니다.",
  "common.locationRemovedFromFavorites": "즐겨 찾기에서 제거 된 위치",
  "common.locations": "위치",
  "common.low": "낮은",
  "common.manage": "관리하다",
  "common.manageAccount": "계정 관리",
  "common.manageMySubscription": "내 구독 관리",
  "common.manageSensors": "센서 관리",
  "common.manageSensorsDescription": "항목을 드래그하여 센서 순서를 변경하세요. 눈 아이콘을 탭하여 센서를 표시하거나 숨기세요. 이름을 탭하여 변경하세요.",
  "common.manualBoost": "수동 부스트",
  "common.manualSetpointUntil": "수동 설정점",
  "common.mapLayers": "지도 레이어",
  "common.mapLegend": "지도 범례",
  "common.maxFavoriteLocationsReached": "최대 5 개의 좋아하는 위치 만 가질 수 있습니다. 다른 것을 추가하려면 하나를 제거하십시오.",
  "common.measureToDisplay": "표시할 측정",
  "common.medium": "중간",
  "common.meshSize": "그리드 크기",
  "common.minRead": "{minutes}분 읽기",
  "common.modifyFavoriteStations": "좋아하는 스테이션을 수정하십시오",
  "common.modifyFavoriteStationsDescription": "좋아하는 스테이션을 드래그하여 재정렬 할 수 있습니다. 목록에서 제거 할 수도 있습니다.",
  "common.moduleType": "모듈 유형",
  "common.monthTotal": "월 합계",
  "common.more": "더",
  "common.moreInformation": "추가 정보",
  "common.myLocation": "내 위치",
  "common.nearbyWeatherStations": "인근 기상 관측소",
  "common.next": "다음",
  "common.nextHours": "다음 시간",
  "common.no": "아니요",
  "common.noAccountNeeded": "계정 필요 없음",
  "common.noDataForThisPeriod": "이 기간에 대한 데이터가 없습니다.",
  "common.noLocationsFound": "위치를 찾을 수 없습니다",
  "common.noNetatmoWeatherStationYet": "아직 Netatmo 기상 관측소가 없습니다.",
  "common.noOutdoorModule": "이 스테이션에는 기능적인 실외 모듈이 없습니다.",
  "common.noStationsFound": "관측소를 찾을 수 없습니다",
  "common.noThermostatYet": "아직 온도 조절기가 없습니다.",
  "common.notNow": "나중에",
  "common.notPurchasedYet": "아직 구매하지 않은 것 같습니다.",
  "common.noWeatherStation": "기상 관측소 없음",
  "common.noWeatherStationYet": "아직 기상 관측소가 없습니다.",
  "common.numberOfActiveWarnings": "{warning_count} 활성 날씨 경고",
  "common.openSettings": "열기 설정",
  "common.orChooseMonthly": "또는 월간 선택:",
  "common.outdatedModule": "이 모듈의 데이터가 오래되었습니다.",
  "common.outdoor": "집 밖의",
  "common.outdoorTemperature": "실외 온도",
  "common.pageNotFound": "페이지를 찾을 수 없습니다",
  "common.pageNotFoundDescription": "찾고 있는 페이지가 존재하지 않거나 이동되었습니다.",
  "common.passwordUpdated": "비밀번호가 성공적으로 업데이트되었습니다.",
  "common.personalWeatherIntelligence": "당신의 개인 날씨 인텔리전스",
  "common.premiumAccount": "프리미엄 계정",
  "common.premiumDescription": "프리미엄 구독을 통해 고급 기상 분석, 차트 비교, 지역 예측 모델 등과 같은 다양한 추가 기능을 사용할 수 있습니다.",
  "common.premiumFeatureAlerts": "날씨 알림",
  "common.premiumFeatureAnalysis": "고급 날씨 분석",
  "common.premiumFeatureCharts": "차트 비교",
  "common.premiumFeatureExport": "데이터 내보내기",
  "common.premiumFeatureForecast": "지역 예보 모델",
  "common.premiumFeatureNotification": "상태 표시줄 위젯",
  "common.premiumFeatureTitle": "프리미엄 기능",
  "common.premiumFeatureWidgets": "홈 화면 위젯",
  "common.pressureSummary": "압력 요약",
  "common.previous": "이전의",
  "common.previousHours": "이전 시간",
  "common.profileUpdated": "프로필이 성공적으로 업데이트되었습니다.",
  "common.purchasedNetatmoPro": "이전에 Netatmo Pro({date})를 구매하셨습니다. 이를 통해 프리미엄 기능의 하위 집합에 액세스할 수 있습니다. 모든 프리미엄 기능에 액세스하려면 다음 혜택 중 하나를 구독하세요.",
  "common.radarDataAttribution": "레이더 데이터: RainViewer.com",
  "common.rain": "비",
  "common.rainEvents": "비 이벤트",
  "common.rainfallMeasurement": "강우량 측정",
  "common.rainRadar": "비 레이더",
  "common.rainRadarDescription": "지도에 레인 레이더 오버레이 표시",
  "common.rainSummary": "비 개요",
  "common.range": "범위",
  "common.recentLocations": "최근의",
  "common.recentLocationsEmpty": "당신의 최근 역사는 비어 있습니다.",
  "common.recentStations": "최근 방송국",
  "common.relatedArticles": "관련 기사",
  "common.relay": "계전기",
  "common.removeFromFavorites": "즐겨 찾기에서 삭제하기",
  "common.renameSensors": "센서 이름 바꾸기",
  "common.resetZoom": "줌 재설정",
  "common.restorePurchase": "구매 복원",
  "common.room": "방",
  "common.rooms": "객실",
  "common.savingsPercent": "{percent}% 절약",
  "common.searchArticles": "기사 검색...",
  "common.searchForALocation": "위치 검색...",
  "common.searchForLocation": "위치 검색",
  "common.searchForWeatherStation": "기상 관측소 검색",
  "common.searchResults": "검색 결과",
  "common.searchResultsEmpty": "결과가 없습니다.",
  "common.searchStationsDescription": "도시, 주소 또는 장소명을 입력하여 주변 기상 관측소를 찾으세요.",
  "common.searchStationsHint": "위의 검색창을 사용하여 전 세계 어디서나 기상 관측소를 찾아보세요.",
  "common.selectStationForComparison": "비교할 역을 선택하세요.",
  "common.selectWeatherForecastProvider": "날씨 제공업체를 선택하세요.",
  "common.serialNumber": "일련번호",
  "common.share": "공유하다",
  "common.shareOutdoorMeasures": "야외 활동을 공유하세요",
  "common.shareOutdoorMeasuresDescription": "야외 측정값을 다른 사람들에게 공개하여 SmartMixin 커뮤니티에 참여하세요. 실내 조치는 절대 공유되지 않습니다.",
  "common.shareYourWeather": "날씨를 공유하세요",
  "common.signalStrength": "신호 강도",
  "common.skip": "건너뛰다",
  "common.smartThermostat": "스마트 온도 조절기",
  "common.smartValve": "스마트 밸브",
  "common.snow": "눈",
  "common.start": "시작",
  "common.startFreeTrial": "무료 체험 시작",
  "common.startTime": "시작 시간",
  "common.station": "관측소",
  "common.stationAddedToFavorites": "즐겨찾기에 채널이 추가되었습니다",
  "common.stationComparison": "역비교",
  "common.stationComparisonDescription": "과거 기상 데이터를 다른 관측소와 비교",
  "common.stationInformation": "역정보",
  "common.stationName": "역 이름",
  "common.stationObservationsDescription": "기상 관측소의 최신 관측치를 표시합니다.",
  "common.stationRemovedFromFavorites": "즐겨찾기에서 방송국이 삭제되었습니다.",
  "common.stations": "관측소",
  "common.stationsNear": "주변 관측소",
  "common.stationType": "스테이션 유형",
  "common.statusOffline": "오프라인",
  "common.statusOnline": "온라인",
  "common.statusStale": "오래됨",
  "common.statusSyncing": "동기화 중",
  "common.subscribeNow": "지금 구독 - 체험판 없음",
  "common.sumOverThePeriod": "해당 기간 동안 누적",
  "common.switchToPremium": "SmartMixin 프리미엄으로 전환",
  "common.temperatureShort": "온도",
  "common.temperatureSummary": "온도 요약",
  "common.thankYouForFeedback": "피드백을 주셔서 감사합니다!",
  "common.thenPrice": "이후 {price}",
  "common.timeSelection": "시간 선택",
  "common.timezone": "시간대",
  "common.totalDuration": "총 기간",
  "common.tryAnotherLocation": "이 위치 주변에서 기상 관측소를 찾을 수 없습니다. 다른 지역에서 검색해 보세요.",
  "common.unknown": "알려지지 않은",
  "common.untilChanged": "변경될 때까지",
  "common.untilTime": "{time} 까지",
  "common.upgrade": "업그레이드",
  "common.upgradeRequiredAndroid": "애플리케이션을 업그레이드해야 합니다. 업그레이드하려면 Google Play를 방문하세요.",
  "common.upgradeRequiredIos": "애플리케이션을 업그레이드해야 합니다. 업그레이드하려면 App Store를 방문하세요.",
  "common.validate": "확인",
  "common.validEmail": "유효한 이메일 주소가 요구됩니다.",
  "common.very_low": "매우 낮은",
  "common.visitNetatmoWebsite": "Netatmo 웹사이트 방문",
  "common.wasArticleHelpful": "이 기사가 도움이 되셨나요?",
  "common.weatherCondition": "날씨 상태",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain은 Nearcast Technology를 기반으로 하는 Tempest Weather System을 통해 제공되는 추가 데이터 소스입니다. NC Rain 데이터는 지역 수준에서 Tempest 주변의 평균 강수량 누적에 대한 추정치입니다.",
  "common.weatherForecastModels": "일기예보 모델",
  "common.weatherIntelligencePlatform": "날씨 인텔리전스 플랫폼",
  "common.weatherMap": "기상도",
  "common.weatherMapMetaDescription": "SmartMixin은 전 세계 기상 조건에 대한 대화형 날씨 및 레이더 지도를 제공합니다.",
  "common.weatherObservations": "기상 관측",
  "common.weatherStation": "기상청",
  "common.weatherStations": "기상 관측소",
  "common.welcome": "SmartMixin에 오신 것을 환영합니다!",
  "common.whenBackHome": "언제 집에 돌아올 거예요?",
  "common.wifiStrength": "WiFi 강도",
  "common.wind": "바람",
  "common.windMeasurement": "바람 측정",
  "common.windSpeed": "풍속",
  "common.windSummary": "바람 개요",
  "common.yearToDate": "올해 초부터 현재까지",
  "common.yes": "예",
  "intro.locationDescription": "정확한 지역 기반 예보를 위해 위치 접근을 허용해 주세요 — 더 이상 일반적인 예보는 없습니다.",
  "intro.locationTitle": "당신을 위한 맞춤형 예보",
  "intro.notificationDescription": "비, 눈 또는 심각한 기상 상황에 대해 실시간으로 알림을 받아보세요. 필요한 순간에 정확히 알려드립니다.",
  "intro.notificationsTitle": "날씨 변화를 놓치지 마세요",
  "intro.readyDescription": "정확한 예보, 실시간 날씨 정보, 그리고 전 세계 기상 관측소 데이터를 하나의 강력한 앱에서 만나보세요.",
  "intro.readyTitle": "모든 준비 완료!",
  "intro.welcomeDescription": "최고의 기상 기관들이 제공하는 초지역 날씨 예보와 함께, 전 세계 40,000개 이상의 기상 관측소에서 실제 과거 및 현재의 날씨를 확인할 수 있어요.",
  "intro.welcomeTitle": "당신만의 날씨, 새롭게 정의하다",
  "landing.alerts": "경고",
  "landing.alertsDescription": "나만의 알림을 만들고 트리거되는 즉시 알림을 받으세요.",
  "landing.featureAlertsDescription": "관심 있는 조건에 대한 맞춤 알림을 설정하세요—온도, 바람, 강수량 등.",
  "landing.featureAlertsTitle": "스마트 알림",
  "landing.featureAnalyticsDescription": "대화형 차트, 나란히 비교, 기본 지표를 넘어선 트렌드 분석으로 데이터를 깊이 탐색하세요.",
  "landing.featureAnalyticsTitle": "강력한 분석",
  "landing.featureExportDescription": "Excel 분석, 다른 시스템과의 통합 또는 백업용으로 CSV 형식으로 데이터를 다운로드하세요.",
  "landing.featureExportTitle": "어디서나 내보내기",
  "landing.featureForecastDescription": "GFS, ECMWF, ICON 등 10개 이상의 기상 모델 예보를 비교하여 지역에 가장 적합한 모델을 찾으세요.",
  "landing.featureForecastTitle": "예보 비교",
  "landing.featureHistoryDescription": "시간별, 일별, 월별 스케일의 과거 데이터에 접근하세요. 연구나 개인 보관용으로 CSV로 내보내기 가능.",
  "landing.featureHistoryTitle": "풍부한 기록",
  "landing.featureMultiBrandDescription": "Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow 등의 관측소를 연결—모두 하나의 대시보드에서.",
  "landing.featureMultiBrandTitle": "멀티 브랜드 지원",
  "landing.featuresSubtitle": "기본 기상 관측소 앱 이상을 원하는 날씨 애호가를 위해 설계되었습니다.",
  "landing.featuresTitle": "날씨 분석에 필요한 모든 것",
  "landing.finalCtaButton": "무료 계정 만들기",
  "landing.finalCtaSubtitle": "기상 데이터를 위해 SmartMixin을 신뢰하는 수천 명의 날씨 애호가와 함께하세요.",
  "landing.finalCtaTitle": "기상 경험을 업그레이드할 준비가 되셨나요?",
  "landing.forecastDescription": "최고의 일기 예보 모델 중 일부에 액세스하고 이를 비교하여 날씨가 어떻게 될지에 대한 자신만의 아이디어를 얻으십시오.",
  "landing.forecasts": "예측",
  "landing.heroCta": "무료로 시작",
  "landing.heroDescription": "모든 브랜드의 여러 기상 관측소를 통합하고, 예보 모델을 비교하며, 상세한 차트와 내보내기로 데이터를 분석하세요.",
  "landing.heroSecondaryCta": "기능 보기",
  "landing.heroTagline": "모든 기상 데이터. 하나의 플랫폼.",
  "landing.heroTitle": "모든 기상 데이터. 하나의 플랫폼.",
  "landing.pricingFeatureAdvancedMetrics": "고급 지표",
  "landing.pricingFeatureAlerts": "맞춤 알림",
  "landing.pricingFeatureExport": "데이터 내보내기 (CSV)",
  "landing.pricingFeatureForecastComparison": "예보 비교",
  "landing.pricingFeatureForecasts": "예보 모델",
  "landing.pricingFeatureForecastsFreeTier": "1개 모델",
  "landing.pricingFeatureForecastsPremiumTier": "모든 모델 (10개 이상)",
  "landing.pricingFeatureReports": "분석 및 보고서",
  "landing.pricingFeatureStationComparison": "관측소 비교",
  "landing.pricingFeatureWidgets": "홈 화면 위젯",
  "landing.pricingFeatureYearOverYear": "전년 대비 분석",
  "landing.pricingFree": "무료",
  "landing.pricingFreeCta": "시작하기",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "가장 인기",
  "landing.pricingPremium": "프리미엄",
  "landing.pricingPremiumCta": "시작하기",
  "landing.pricingPremiumDescription": "월 1.99€부터 — 웹, App Store 또는 Google Play에서 구독",
  "landing.pricingSubtitle": "무료로 시작하고, 더 필요할 때 업그레이드하세요.",
  "landing.pricingTitle": "간단하고 투명한 가격",
  "landing.smartMixinDescription": "SmartMixin은 기상 관측소와 전 세계 40,000개 이상의 기타 관측소에 대한 액세스를 제공하는 애플리케이션입니다. 날씨 데이터를 보고 이해하는 데 도움이 됩니다.",
  "landing.statBrands": "지원 브랜드",
  "landing.statForecasts": "예보 모델",
  "landing.statStations": "연결된 관측소",
  "landing.supportedDevices": "지원되는 장치",
  "landing.supportedDevicesDescription": "세계기상기구(World Meteorological Organization)의 관측소 외에도 SmartMixin은 점점 더 많은 기상 관측소 브랜드를 지원합니다.",
  "landing.supportedDevicesNote": "세계기상기구의 40,000개 이상의 공공 관측소 포함",
  "landing.supportedDevicesSubtitle": "주요 브랜드의 기상 관측소를 연결하고 모든 데이터를 한 곳에서 확인하세요.",
  "landing.supportedDevicesTitle": "귀하의 관측소와 작동",
  "landing.thermostatDescription": "Netatmo 온도 조절기를 연결하여 난방 패턴과 외부 조건을 비교하세요.",
  "landing.thermostatManufacturers": "온도 조절기 제조업체는 난방과 실외 조건의 상관 관계를 지원합니다.",
  "landing.thermostatTitle": "스마트 홈 통합",
  "landing.weatherAnalysis": "날씨 분석",
  "landing.weatherAnalysisDescription": "SmartMix에는 날씨 데이터를 분석할 수 있는 다양한 데이터 시각화 기능이 포함되어 있습니다.",
  "landing.weatherAssistant": "날씨 도우미",
  "landing.weatherAssistantDescription": "현재, 과거 또는 예측 기상 조건에 관심이 있든 상관없이 SmartMixin은 필요할 때마다 수많은 통찰력을 제공합니다.",
  "landing.weatherForecastModels": "일기예보 모델",
  "landing.weatherForecastModelsDescription": "SmartMixin은 가장 정확한 일기 예보 모델에 대한 액세스를 제공합니다. 그들의 예측을 쉽게 비교하고 자신만의 아이디어를 만들 수 있습니다.",
  "landing.weatherMap": "날씨 지도",
  "landing.weatherMapDescription": "지도를 탐색하고 전 세계 어디든 날씨가 어떤지 시각화해 보세요.",
  "network.cancelError": "요청이 취소되었습니다",
  "network.connectionError": "서버를 사용할 수 없습니다",
  "network.networkError": "네트워크를 사용할 수 없음",
  "network.serverError": "문제가 발생했습니다.",
  "network.timeoutError": "접속 시간 초과",
  "network.unknownError": "알수없는 오류",
  "providerHints.ambientWeatherApiKey": "ambientweather.net 계정 설정에서 생성됩니다.",
  "providerHints.davisApiSecret": "V2 API 키를 만들 때 한 번만 표시됩니다 — 안전하게 보관하세요.",
  "providerHints.davisV2ApiKey": "weatherlink.com의 V2 API 키 페이지에서 가져옵니다.",
  "providerHints.ecowittApi": "Ecowitt 계정의 API 페이지에서 가져옵니다.",
  "providerHints.ecowittApp": "애플리케이션 키도 Ecowitt 계정에서 가져옵니다.",
  "providerHints.myAcuriteCredentialsBanner": "My AcuRite 계정의 이메일과 비밀번호를 사용하세요 — SmartMixin 로그인이 아닙니다.",
  "providerHints.myAcuriteEmail": "My AcuRite 계정의 이메일 — SmartMixin 로그인이 아닙니다.",
  "providerHints.myAcuritePassword": "My AcuRite 계정의 비밀번호.",
  "providerHints.weatherflowToken": "tempestwx.com → 설정 → 데이터 인증에서 가져오는 개인용 토큰.",
  "providerHints.wundergroundEditKey": "다른 키 사용",
  "providerHints.wundergroundKey": "Weather Underground 계정의 API 키 페이지에서 가져온 긴 문자열입니다 — wunderground.com 비밀번호가 아닙니다.",
  "providerHints.wundergroundKeyExample": "예: 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "API 키가 확인되었습니다",
  "providerHints.wundergroundKeyVerifying": "키 확인 중…",
  "providerHints.wundergroundNoStationsNearby": "이 위치 근처에서 스테이션을 찾을 수 없습니다. 스테이션 ID를 직접 입력해 보세요.",
  "providerHints.wundergroundStationId": "Weather Underground의 모든 스테이션 ID — 본인의 것이거나 근처의 공개 스테이션도 가능합니다.",
  "providerHints.wundergroundStationIdExample": "예: KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Ambient Weather API 키를 받으세요.",
  "providerIntro.davisStep2": "Davis V2 API 키와 API 시크릿을 받으세요.",
  "providerIntro.ecowittStep2": "Ecowitt API 키와 애플리케이션 키를 받으세요.",
  "providerIntro.getStarted": "시작하기",
  "providerIntro.myAcuriteStep2": "기존 My AcuRite 계정의 이메일과 비밀번호를 사용하세요.",
  "providerIntro.netatmoEnergyStep2": "요청이 있을 때 Netatmo에 로그인하세요 — API 키가 필요하지 않습니다.",
  "providerIntro.netatmoWeatherStep2": "요청이 있을 때 Netatmo에 로그인하세요 — API 키가 필요하지 않습니다.",
  "providerIntro.signupBanner": "거의 다 됐습니다 — {provider}를 연결하려면 무료 SmartMixin 계정을 만드세요.",
  "providerIntro.step1": "SmartMixin 계정에 로그인하세요 ({provider} 로그인이 아닙니다).",
  "providerIntro.step3EmailPassword": "여기에 입력하세요.",
  "providerIntro.step3KeyOrToken": "여기에 붙여넣으세요.",
  "providerIntro.step3OAuth": "팝업에서 SmartMixin을 승인하세요.",
  "providerIntro.step3Wunderground": "API 키를 붙여넣은 다음 가까운 스테이션을 선택하거나 임의의 스테이션 ID를 입력하세요.",
  "providerIntro.title": "{provider} 연결",
  "providerIntro.weatherflowStep2": "개인용 Tempest 토큰을 받으세요.",
  "providerIntro.wundergroundBrowsePublic": "스테이션이 없으신가요? 공개 스테이션 둘러보기",
  "providerIntro.wundergroundFindNearby": "주변 스테이션 찾기",
  "providerIntro.wundergroundOrEnterId": "또는 스테이션 ID 입력",
  "providerIntro.wundergroundStep2": "Weather Underground API 키를 받으세요. 그러면 본인의 스테이션이든 공개 스테이션이든 어떤 스테이션이든 연결할 수 있습니다.",
  "reports.agroMeteorology": "농업기상학",
  "reports.analysis": "분석",
  "reports.annualCumulativeRainfallComparison": "연간 누적 강우량 비교",
  "reports.annualHeatingDurationComparison": "연간 난방시간 비교",
  "reports.annualHeatingEfficiency": "연간 난방효율",
  "reports.annualIndoorComparison": "연간 실내 비교",
  "reports.annualIndoorReport": "연간 실내 보고서",
  "reports.annualOutdoorComparison": "연간 야외 비교",
  "reports.annualOutdoorReport": "연례 야외 보고서",
  "reports.annualReport": "연간 보고서",
  "reports.annualSolarReport": "연간 태양광 보고서",
  "reports.annualWaterBalance": "연간 물 균형",
  "reports.annualWaterBalanceCarryOver": "전년도 이월",
  "reports.annualWaterBalanceDescription": "물 균형(단순 버전, 비와 증발산만 사용)은 물 공급 관리에 도움이 됩니다.",
  "reports.avgHumidity": "평균 습도",
  "reports.avgMaxTemperature": "평균 T°max",
  "reports.avgMinTemperature": "평균 T°min",
  "reports.avgPressure": "평균 압력",
  "reports.avgTemperature": "평온",
  "reports.comfortable": "편안함(45% {lessThan} 습도 ≤ 60%)",
  "reports.cumulativeRainfall": "누적 강우량",
  "reports.cumulativeRainfallDescription": "선택한 기간에 누적된 총 강우량을 확인하세요.",
  "reports.dailyMaxRainfall": "일일 최대 강우",
  "reports.dataExport": "데이터 내보내기",
  "reports.dataExportXlsxFormatDescription": "스테이션의 모든 데이터를 Excel 형식(*.xlsx)으로 내보냅니다. 버튼을 클릭하면 몇 분 후에 처리된 데이터가 포함된 이메일을 받게 됩니다.",
  "reports.daysWithFrost": "서리가 내리는 날",
  "reports.daysWithoutThaw": "해빙되지 않는 날",
  "reports.daysWithStrongFrost": "서리가 많이 내리는 날",
  "reports.emailSent": "이메일이 귀하의 사서함으로 전송되었습니다",
  "reports.grasslandTemperatureSum": "초원 온도 합계",
  "reports.grasslandTemperatureSumDescription": "봄에 {threshold} 의 합계가 초과되면 지속 가능한 식생 시작에 도달한 것입니다(유럽에서 작동).",
  "reports.growingDegreeDays": "생육적산온도",
  "reports.highPressure": "안티사이클론 (평균 압력 ≥ 1013mbar)",
  "reports.indoorReport": "실내 보고서",
  "reports.keyFacts": "중요한 사실",
  "reports.longestRunOfRainyDays": "비 오는 날 최장기간 운행",
  "reports.longestRunWithoutRun": "비 없이 최장거리 달리기",
  "reports.lowPressure": "저압 (평균 압력 {lessThan} 1013mbar)",
  "reports.maxHumidity": "최대 습도",
  "reports.maxPressure": "최대 압력",
  "reports.maxPressureMagnitude24h": "최대 크기(/24H)",
  "reports.maxTemperature": "최대 온도",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "최대 크기(/24H)",
  "reports.minHumidity": "최소 습도",
  "reports.minPressure": "최소 압력",
  "reports.minPressureMagnitude24h": "최소 크기(/24H)",
  "reports.minTemperature": "최저온도",
  "reports.minTempMagnitude24h": "최소 크기(/24H)",
  "reports.monthlyHeatingEfficiency": "월별 난방효율",
  "reports.monthlyIndoorReport": "월간 실내 보고서",
  "reports.monthlyOutdoorReport": "월간 야외 보고서",
  "reports.monthlyReport": "월별보고",
  "reports.monthlySolarReport": "월간 태양광 보고서",
  "reports.monthlyWindReport": "월간 바람 보고서",
  "reports.numberOfDays": "일 수",
  "reports.outdoorReport": "옥외보고",
  "reports.rainfall": "강우",
  "reports.rainyDays": "비오는 날",
  "reports.relativelyWet": "상대적으로 습함(60% {lessThan} 습도 ≤ 80%)",
  "reports.sendEmail": "이메일을 보내",
  "reports.tooDry": "너무 건조함(습도 45% 이하)",
  "reports.tooWet": "너무 습함(습도 {greaterThan} 80%)",
  "reports.tropicalNights": "열대의 밤",
  "reports.waterBalance": "수분 균형",
  "reports.yearToDateTemperature": "연초 대비 기온",
  "reports.yearToDateTemperatureComparison": "연간 기온 비교",
  "sensors.aqiByChannel": "채널별 AQI",
  "sensors.bgtSensors": "흑구 & WBGT",
  "sensors.cameraFeed": "카메라",
  "sensors.compareAqi": "AQI 비교",
  "sensors.compareHumidity": "습도 비교",
  "sensors.compareMoisture": "토양 수분 비교",
  "sensors.comparePm25": "PM2.5 비교",
  "sensors.compareTemperatures": "온도 비교",
  "sensors.depthByChannel": "채널별 깊이",
  "sensors.heatStressExtreme": "극심한 열 스트레스",
  "sensors.heatStressModerate": "보통 열 스트레스",
  "sensors.heatStressNone": "열 스트레스 없음",
  "sensors.heatStressStrong": "강한 열 스트레스",
  "sensors.heatStressVeryStrong": "매우 강한 열 스트레스",
  "sensors.humidityByChannel": "채널별 습도",
  "sensors.indoorAirQuality": "실내 공기질",
  "sensors.indoorAirQualityPm": "PM2.5 & PM10 AQI",
  "sensors.indoorClimate": "실내 기후",
  "sensors.indoorCo2Levels": "CO2 수준",
  "sensors.indoorTemperatureAndHumidity": "온도 및 습도",
  "sensors.last24Hours": "24시간",
  "sensors.last30Days": "30일",
  "sensors.last7Days": "7일",
  "sensors.leafTemperatureByChannel": "채널별 잎 온도",
  "sensors.leafWetnessByChannel": "채널별 잎 습도",
  "sensors.lightningSensor": "번개",
  "sensors.moistureByChannel": "채널별 토양 수분",
  "sensors.noDataAvailable": "데이터 없음",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "채널별 PM2.5",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "채널 선택",
  "sensors.sensorDetailDescription": "센서 채널의 과거 데이터와 추세를 확인하세요.",
  "sensors.sensorHistory": "센서 기록",
  "sensors.soilConductivityByChannel": "채널별 전도도",
  "sensors.soilTemperatureByChannel": "채널별 토양 온도",
  "sensors.strikesToday": "오늘 낙뢰 수",
  "sensors.temperatureByChannel": "채널별 온도",
  "settings.about": "에 대한",
  "settings.aboutDescription": "라이센스 계약, 개인 정보 보호 정책",
  "settings.account": "계정",
  "settings.accountDescription": "프로필, 비밀번호 변경",
  "settings.accountIntro": "데이터는 귀하의 계정과 관련됩니다:",
  "settings.accountSection": "계정",
  "settings.appearance": "외관",
  "settings.appearanceDescription": "테마 및 표시 옵션",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "아랍어",
  "settings.availableServices": "사용 가능",
  "settings.bulgarian": "불가리아 사람",
  "settings.cannotDisconnectLastAccount": "유일한 로그인 방법의 연결을 해제할 수 없습니다. 먼저 다른 로그인 방법을 추가하세요.",
  "settings.changeEmail": "이메일 변경",
  "settings.changePassword": "비밀번호 변경",
  "settings.chartGestures": "차트의 제스처",
  "settings.chartGesturesDescription": "차트를 스와이프하면 기간이 변경되고, 차트를 핀치하면 시간 척도가 변경됩니다.",
  "settings.connect": "연결",
  "settings.connected": "연결됨",
  "settings.connectedAccounts": "연결된 계정",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "연결됨",
  "settings.connectedSince": "{date}부터 연결됨",
  "settings.connectionSuccess": "{provider} 계정이 성공적으로 연결되었습니다",
  "settings.contactUs": "문의하기",
  "settings.contactUsDescription": "도움을 받거나 피드백을 보내세요",
  "settings.croatian": "크로아티아어",
  "settings.currentPassword": "현재 비밀번호",
  "settings.czech": "체코 사람",
  "settings.danish": "덴마크 말",
  "settings.dark": "어두운 테마",
  "settings.dataDisplay": "데이터 표시",
  "settings.dateAndTime": "날짜와 시간",
  "settings.disconnect": "연결 해제",
  "settings.disconnectConfirmation": "{provider} 계정 연결을 해제하시겠습니까?",
  "settings.disconnectionSuccess": "{provider} 계정이 성공적으로 연결 해제되었습니다",
  "settings.donateButton": "기부하기",
  "settings.donateDescription": "SmartMixin은 소규모 팀이 개발하고 있습니다. 유용하게 사용하고 계신다면 원하는 금액의 일회성 기부로 개발을 후원하실 수 있습니다. 이것은 선물이며, 요금제를 변경하거나 어떤 기능도 잠금 해제하지 않습니다.",
  "settings.donateSuccessBody": "여러분의 기부는 SmartMixin을 운영하고 개선하는 데 도움이 됩니다. 진심으로 감사드립니다.",
  "settings.donateSuccessTitle": "후원해 주셔서 감사합니다!",
  "settings.donateTitle": "SmartMixin 후원하기",
  "settings.dutch": "네덜란드 사람",
  "settings.emailChange": "이메일 주소 변경",
  "settings.emailChangeConfirmation": "이메일 변경 확인",
  "settings.emailChangeFailure": "이메일 변경 링크가 유효하지 않거나 만료되었습니다.",
  "settings.emailChangeSuccess": "이메일이 {newEmail}로 성공적으로 변경되었습니다.",
  "settings.emailChangeVerificationSent": "새 이메일 주소로 확인 이메일이 전송되었습니다. 받은 편지함을 확인하고 링크를 클릭하여 변경을 확인하세요.",
  "settings.english": "영어",
  "settings.forecastModelOrderEmpty": "저장된 순서 없음 — 기본적으로 GFS를 사용합니다.",
  "settings.forecastModelOrderFreeHint": "프리미엄 모델에는 SmartMixin Premium 구독이 필요합니다.",
  "settings.forecastModelOrderHelp": "각 관측소를 포함하는 목록의 첫 번째 모델을 선택합니다.",
  "settings.forecastModelOrderReset": "기본값으로 재설정",
  "settings.forecastModelOrderTitle": "기본 예보 모델",
  "settings.forecastModels": "예보 모델",
  "settings.forecastModelsDescription": "선호도에 따라 재정렬",
  "settings.french": "프랑스 국민",
  "settings.german": "독일 사람",
  "settings.gestures": "제스처",
  "settings.greek": "그리스 사람",
  "settings.helpCenter": "도움말 센터",
  "settings.helpCenterDescription": "FAQ 및 가이드",
  "settings.hungarian": "헝가리 인",
  "settings.integrationsSection": "통합",
  "settings.italian": "이탈리아 사람",
  "settings.japanese": "일본어",
  "settings.korean": "한국인",
  "settings.language": "언어",
  "settings.languageDescription": "선호하는 언어",
  "settings.light": "밝은 테마",
  "settings.newEmailAddress": "새 이메일 주소",
  "settings.newPassword": "새 비밀번호",
  "settings.newPasswordAgain": "새로운 비밀번호를 다시",
  "settings.norwegian": "노르웨이 인",
  "settings.notConnected": "연결되지 않음",
  "settings.notificationsSection": "알림",
  "settings.oldPassword": "기존 비밀번호",
  "settings.ongoingNotificationEnabled": "상시 알림 활성화",
  "settings.ongoingNotificationMetrics": "표시할 측정값",
  "settings.ongoingNotificationMetricsHint": "드래그하여 선택한 측정값 순서 변경",
  "settings.ongoingNotificationPermissionRequired": "알림 권한이 필요합니다",
  "settings.ongoingNotificationStation": "기상 관측소",
  "settings.passwordChange": "비밀번호 변경",
  "settings.polish": "광택",
  "settings.portuguese": "포르투갈 인",
  "settings.preferencesSection": "환경설정",
  "settings.premium": "프리미엄",
  "settings.premiumActive": "활성",
  "settings.premiumAnnualThenPrice": "이후 9.99 €/년",
  "settings.premiumAnnualTrialInfo": "{days}일 무료 체험으로 시작하세요",
  "settings.premiumCurrentPlan": "현재 플랜",
  "settings.premiumDescription": "프리미엄 기능 잠금 해제",
  "settings.premiumDownloadApp": "구독하려면 앱을 다운로드하세요:",
  "settings.premiumExpiresOn": "{date}에 갱신",
  "settings.premiumFreePlan": "무료",
  "settings.premiumInactive": "미구독",
  "settings.premiumManageWebSubscription": "구독을 관리하고, 결제 수단을 업데이트하거나 취소하세요.",
  "settings.premiumPremiumPlan": "프리미엄",
  "settings.premiumSubscribeAnnual": "연간 — 9.99 €/년",
  "settings.premiumSubscribedOn": "{platform}에서 구독 중",
  "settings.premiumSubscribeMonthly": "월간 — 1.99 €/월",
  "settings.premiumSubscribeOnWeb": "지금 구독하여 모든 프리미엄 기능을 잠금 해제하세요.",
  "settings.premiumSubscriptionSuccess": "구독이 활성화되었습니다! 모든 프리미엄 기능을 즐기세요.",
  "settings.premiumSubscriptionSuccessTitle": "프리미엄에 오신 것을 환영합니다!",
  "settings.premiumWebappNotice": "구독은 iOS 또는 Android의 SmartMixin 모바일 앱에서만 가능합니다.",
  "settings.privacyPolicy": "개인 정보 정책",
  "settings.profile": "프로필",
  "settings.russian": "러시아인",
  "settings.serbian": "세르비아 사람",
  "settings.settings": "설정",
  "settings.slovak": "슬로바키아 사람",
  "settings.smallDecimals": "작은 소수점",
  "settings.smallDecimalsDescription": "소수점 이하 숫자를 작은 크기로 표시",
  "settings.socialConnectionsIntro": "소셜 계정을 연결하여 빠르게 로그인하세요. 언제든지 계정을 연결하거나 연결 해제할 수 있습니다.",
  "settings.spanish": "스페인의",
  "settings.statusBarWidget": "상태 표시줄 위젯",
  "settings.statusBarWidgetDescription": "항상 표시되는 날씨 데이터",
  "settings.subscriptionSection": "구독",
  "settings.supportSection": "지원",
  "settings.swedish": "스웨덴어",
  "settings.systemTheme": "시스템 테마",
  "settings.termsOfService": "서비스 약관",
  "settings.turkish": "터키",
  "settings.ukrainian": "우크라이나 인",
  "settings.units": "단위",
  "settings.unitsDescription": "애플리케이션 내에 표시되는 측정 단위",
  "settings.update": "업데이트",
  "settings.updateYourProfile": "프로필 업데이트",
  "settings.weatherServices": "기상 서비스",
  "settings.weatherServicesConnected": "{count, plural, =0 {연결된 서비스 없음} other {#개의 서비스가 연결됨}}",
  "settings.weatherServicesDescription": "Netatmo, Davis, Weatherflow 등 연결",
  "settings.windDirectionConvention": "풍향 화살표",
  "settings.windDirectionConventionDescription": "풍향 화살표 표시 방법 선택",
  "settings.windDirectionMeteorological": "풍원 방향",
  "settings.windDirectionMeteorologicalDescription": "화살표가 바람이 불어오는 방향을 가리킵니다 (meteorological convention)",
  "settings.windDirectionOceanographic": "풍류 방향",
  "settings.windDirectionOceanographicDescription": "화살표가 바람이 불어가는 방향을 가리킵니다 (oceanographic convention)",
  "units.absolutePressure": "절대압력",
  "units.airDensity": "공기 밀도",
  "units.airGap": "에어 갭",
  "units.apparentTemperature": "체감 온도",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "평균",
  "units.beaufort": "보퍼트",
  "units.blackGlobeTemperature": "흑구 온도",
  "units.boilerOn": "보일러 ON",
  "units.co2": "CO2",
  "units.conductivity": "전도도",
  "units.coolingDegreeDays": "냉방도일",
  "units.dailyHeatingDuration": "일일 난방 시간",
  "units.dailyPrecipitation": "일 강수량",
  "units.dailyRain": "일일 강우량",
  "units.degreeDay": "학위일",
  "units.degreeDayShort": "DD",
  "units.depth": "깊이",
  "units.depthSensors": "깊이 센서",
  "units.dewPoint": "이슬점",
  "units.distance": "거리",
  "units.downTrend": "아래에",
  "units.E": "이자형",
  "units.E_long": "동쪽",
  "units.ENE": "에네",
  "units.ENE_long": "동북동",
  "units.ESE": "ESE",
  "units.ESE_long": "동남동",
  "units.ET": "증발산",
  "units.ETshort": "동부 표준시",
  "units.feelLike": "같은 느낌",
  "units.feelsLike": "같은 느낌",
  "units.footMile": "피트, 마일",
  "units.frostPoint": "서리점",
  "units.gust": "격발",
  "units.heatIndex": "열지수",
  "units.heatingDegreeDays": "난방도일",
  "units.heatingPower": "난방력",
  "units.humidex": "휴미덱스",
  "units.humidity": "습기",
  "units.inch": "인치",
  "units.inchOfMercury": "수은의 인치",
  "units.kilometerPerHour": "시간당 킬로미터",
  "units.knot": "매듭",
  "units.last12Hours": "지난 12시간",
  "units.last24Hours": "지난 24시간",
  "units.last3Hours": "지난 3시간",
  "units.last6Hours": "지난 6시간",
  "units.lastHour": "지난 시간",
  "units.lastLightningImpact": "라스트 임팩트",
  "units.lastMeasure": "마지막 측정",
  "units.leafSensors": "나뭇잎 센서",
  "units.leafWetness": "잎의 젖음",
  "units.lightningDistance": "거리",
  "units.lightningStrikeCount": "낙뢰 횟수",
  "units.lightningStrikeDistance": "낙뢰 거리",
  "units.max": "최대.",
  "units.max_gust": "최대. 격발",
  "units.max_wind": "최대. 바람",
  "units.meterKilometer": "미터, 킬로미터",
  "units.meterPerSecond": "초당 미터",
  "units.milePerHour": "시간 당 마일",
  "units.millibar": "밀리바",
  "units.millimeter": "밀리미터",
  "units.millimeterOfMercury": "수은 밀리미터",
  "units.min": "최소",
  "units.N": "N",
  "units.N_long": "북쪽",
  "units.NE": "북동쪽",
  "units.NE_long": "북동",
  "units.NNE": "NNE",
  "units.NNE_long": "북북동",
  "units.NNW": "뉴뉴얼",
  "units.NNW_long": "북북서쪽",
  "units.noise": "소음",
  "units.normalizedHeatingCoefficient": "표준화된 가열 계수",
  "units.NW": "북서쪽",
  "units.NW_long": "북서",
  "units.O3": "오존",
  "units.PM_1": "PM1",
  "units.PM_10": "PM10",
  "units.PM_2P5": "PM2.5",
  "units.precipitation": "강수량",
  "units.pressure": "압력",
  "units.rain": "비",
  "units.rainRate": "강수 강도",
  "units.referenceTemperature": "기준온도",
  "units.relativePressure": "상대압력",
  "units.S": "에스",
  "units.S_long": "남쪽",
  "units.SE": "남동쪽",
  "units.SE_long": "남동",
  "units.setPoint": "설정값",
  "units.snow": "눈",
  "units.snowfall": "강설량",
  "units.soilMoisture": "수분",
  "units.soilSensors": "토양 센서",
  "units.solarEnergy": "태양 에너지",
  "units.solarRadiation": "태양 복사",
  "units.speed": "속도",
  "units.SSE": "SSE",
  "units.SSE_long": "남남동",
  "units.SSW": "SSW",
  "units.SSW_long": "남남서쪽",
  "units.stableTrend": "안정적인",
  "units.sum": "합집합",
  "units.SW": "남서",
  "units.SW_long": "남서",
  "units.temperature": "온도",
  "units.temperatureAndHumiditySensors": "온도 및 습도 센서",
  "units.temperatureSensors": "온도 및 습도 센서",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "오늘",
  "units.upTrend": "위로",
  "units.uv": "자외선",
  "units.visibility": "시계",
  "units.W": "여",
  "units.W_long": "서쪽",
  "units.wetBulbGlobeTemperature": "습구흑구온도",
  "units.wetBulbTemperature": "습구온도",
  "units.wind": "바람",
  "units.windChill": "차가운 바람",
  "units.windDirection": "풍향",
  "units.windRun": "윈드런",
  "units.windRunDescription": "Wind Run은 일정 기간 동안 이동한 바람의 총 거리입니다.",
  "units.WNW": "북서쪽",
  "units.WNW_long": "서북서부",
  "units.WSW": "WSW",
  "units.WSW_long": "서남서부"
}
